import Proxy from './Proxy';

export class DashboardProxy extends Proxy {
  constructor(parameters) {
    super(`${process.env.REACT_APP_API_URL}`, parameters);
  }
  addImage = (payload) => {
    let endpoint = `/${payload.keyOne}`;
    if(payload.idOne){
      endpoint += `/${payload.idOne}`;
    }
    if(payload.keyTwo){
      endpoint += `/${payload.keyTwo}`;
    }
    let headers = {
      'Content-Type': 'multipart/form-data;'
    }
    return this.submit('post', `${endpoint}`, payload.data, headers);
  }
};



// WEBPACK FOOTER //
// ./src/proxies/DashboardProxy.js